import { IHooksUseRequestBanUserParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};

type TDataVariables = IHooksUseRequestBanUserParams;
type TResponseData = void;

export const useRequestBanUser = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.users.base, 'ban'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .post<TResponseData>(routes.api.users.ban, data)
        .then(handleApiResponse)
        .then(() => broadcastService.events.publish({ type: 'userBanned', data })),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.subAccounts),
          invalidate(routes.api.searchUser),
          invalidate(routes.api.users.base),
          invalidate(routes.api.reports.base)
        ])
    )
  });

  const triggerBanUser = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingBanUser: isPending,
    triggerBanUser,
    error
  });

};  
